$(function(){
    var toggleSection = function() {
        let IdObj = $('input[name=id]');
        if (IdObj.val() == '' || IdObj.val() == undefined) {
            $('#purchase_select').addClass('selling_plan_theme_integration--hidden');
        } else {
            $('#purchase_select').removeClass('selling_plan_theme_integration--hidden');
        }
    };
    toggleSection();
    $('#freequencySelectDiv').hide();
    $('input[name=id]').on('change', function() {
        toggleSection();
    });

    $('input[name=purchaseType]').change(function(){
        if ($(this).val() == 0) {
            $('input[name=selling_plan]').attr('value', '');
            $('#freequencySelectDiv').hide();
            $('#one-time-purchase').attr('checked','checked');
            $('#autoship').removeAttr('checked');
        } else if ($(this).val() == 1) {
            $('input[name=selling_plan]').attr('value', $('#freequencySelect').val());
            $('#freequencySelectDiv').show();
            $('#one-time-purchase').removeAttr('checked');
            $('#autoship').attr('checked','checked');
        }
    });

    $('#freequencySelect').change(function() {
        planSelect();
    });

    var planSelect = function() {
        if ($('input[name=purchaseType]:checked').val() == 1) {
            $('input[name=selling_plan]').attr('value', $('#freequencySelect').val());
        }
    }

    $('#seeDetail').hover(function(){
      $('#tooltip_4ko3namayz').show();
    },function(){
      $('#tooltip_4ko3namayz').hide();
    });

    $('#seeDetail').click(function(){
      $('#seeDetail').focus();
    });
  
     $('#seeDetail').focus(function(){
      $('#tooltip_4ko3namayz').show();
    });

    
});